import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { RegenerateTokenRequest } from '../api/regeneratetoken/regeneratetokenrequest';
import { RegenerateTokenResponse, RegenerateTokenResponseDtoImpl } from '../api/regeneratetoken/regeneratetokenresponse';
import { RegenTokenBuilder } from '../dto/regeneratetoken/regentokenbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { APIProcessorImpl } from './apiProcessor';

export class RegenerateTokenAPIProcessorImpl extends APIProcessorImpl<RegenerateTokenRequest, RegenerateTokenResponse>
{
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new RegenerateTokenResponseDtoImpl(APIFeatures.REGENERATE_TOKEN, "Regenerate Token Successful");
                response.setRegenerateTokenDto(new RegenTokenBuilder(responseMapper.getResponseMap()).buildAll());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new RegenerateTokenResponseDtoImpl(responseMapper.getStatusCode(), responseMapper.getStatusMsg()));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new RegenerateTokenResponseDtoImpl(responseMapper.getStatusCode(), responseMapper.getStatusMsg()));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
       
                this.getAPIFailure(new RegenerateTokenResponseDtoImpl(responseMapper.getStatusCode(), responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/regeneneratetokenapiprocessor.tsx